'use strict';

/**
 * AdminOrganizationsController - contrôleur de gestion des organisations
 */
import appModule from '../../app.module';

angular.module(appModule)
.controller('AdminOrganizationsController', ['$scope', '$http', function($scope, $http) {
  
  // Initialisation des variables de pagination
  $scope.currentPage = 1;
  $scope.itemsPerPage = 10;
  $scope.totalItems = 0;
  $scope.totalPages = 0;
  
  // Génération des données simulées pour le développement
  var mockOrganizations = [];
  var orgTypes = ['Ministère', 'Administration', 'ONG', 'Entreprise', 'Organisation internationale'];
  for (var i = 1; i <= 20; i++) {
    mockOrganizations.push({
      id: i,
      name: 'Organisation ' + i,
      slug: 'organisation-' + i,
      logoUrl: 'assets/images/logo-placeholder.png',
      type: orgTypes[i % orgTypes.length],
      datasetsCount: Math.floor(Math.random() * 10)
    });
  }
  
  // Fonction de recherche et de chargement des organisations
  function loadOrganizations() {
    $http.get('/api/admin/organizations?page=' + ($scope.currentPage - 1) + '&size=' + $scope.itemsPerPage)
      .then(function(response) {
        $scope.organizations = response.data.content;
        $scope.totalItems = response.data.totalElements;
        $scope.totalPages = response.data.totalPages;
      })
      .catch(function() {
        console.error('Erreur lors du chargement des organisations');
        // En mode développement, utiliser les données simulées
        $scope.organizations = mockOrganizations.slice(
          ($scope.currentPage - 1) * $scope.itemsPerPage, 
          $scope.currentPage * $scope.itemsPerPage
        );
        $scope.totalItems = mockOrganizations.length;
        $scope.totalPages = Math.ceil(mockOrganizations.length / $scope.itemsPerPage);
      });
  }
  
  // Génération des numéros de page pour la pagination
  $scope.getPages = function() {
    var pages = [];
    var startPage = Math.max(1, $scope.currentPage - 2);
    var endPage = Math.min($scope.totalPages, $scope.currentPage + 2);
    
    for (var i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    
    return pages;
  };
  
  // Changement de page
  $scope.setPage = function(page) {
    if (page < 1 || page > $scope.totalPages) {
      return;
    }
    $scope.currentPage = page;
    loadOrganizations();
  };
  
  // Ouvrir la modal pour créer une nouvelle organisation
  $scope.openNewOrganizationModal = function() {
    alert('Fonctionnalité non implémentée: Création d\'organisation');
  };
  
  // Éditer une organisation existante
  $scope.editOrganization = function(organization) {
    alert('Fonctionnalité non implémentée: Édition de l\'organisation ' + organization.name);
  };
  
  // Supprimer une organisation
  $scope.deleteOrganization = function(organization) {
    if (confirm('Êtes-vous sûr de vouloir supprimer l\'organisation "' + organization.name + '" ?')) {
      $http.delete('/api/admin/organizations/' + organization.id)
        .then(function() {
          loadOrganizations();
        })
        .catch(function() {
          console.error('Erreur lors de la suppression de l\'organisation');
          // Simuler la suppression en mode développement
          var index = mockOrganizations.findIndex(function(o) { return o.id === organization.id; });
          if (index !== -1) {
            mockOrganizations.splice(index, 1);
            loadOrganizations();
          }
        });
    }
  };
  
  // Chargement initial des organisations
  loadOrganizations();
}]);
